import React from "react";
import { spring, useCurrentFrame, useVideoConfig } from "remotion";

interface OutroProps {
  keywords?: string[];
}

export const ReactbitsGlowOutro: React.FC<OutroProps> = ({ keywords = [] }) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  void keywords;

  const entrance = spring({
    frame,
    fps,
    from: 0,
    to: 1,
    config: { damping: 14, stiffness: 100 },
  });

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
        opacity: entrance,
        transform: `scale(${0.85 + entrance * 0.15})`,
        padding: "0 60px",
        boxSizing: "border-box",
      }}
    >
      {/* Sleek Glowing Card */}
      <div
        style={{
          border: "2px solid rgba(0, 242, 254, 0.4)",
          padding: "50px 40px",
          textAlign: "center",
          background: "rgba(6, 7, 19, 0.85)",
          backdropFilter: "blur(20px)",
          borderRadius: "32px",
          boxShadow:
            "0 25px 50px rgba(0, 0, 0, 0.5), 0 0 30px rgba(0, 242, 254, 0.15)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "24px",
          width: "100%",
          boxSizing: "border-box",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Glow ambient light */}
        <div
          style={{
            position: "absolute",
            top: "-150px",
            width: "300px",
            height: "300px",
            background:
              "radial-gradient(circle, rgba(255, 0, 127, 0.25) 0%, transparent 70%)",
            filter: "blur(40px)",
            zIndex: -1,
          }}
        />

        {/* Instgram Logo Icon */}
        <div
          style={{
            background: "rgba(255, 0, 127, 0.1)",
            border: "1.5px solid rgba(255, 0, 127, 0.4)",
            borderRadius: "50%",
            width: "100px",
            height: "100px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            boxShadow: "0 0 15px rgba(255, 0, 127, 0.2)",
            marginBottom: "10px",
          }}
        >
          <svg
            width="44"
            height="44"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#ff007f"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
            <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
            <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
          </svg>
        </div>

        {/* Call to action text */}
        <div>
          <h2
            style={{
              fontFamily: "var(--font-title)",
              fontSize: "56px",
              fontWeight: 900,
              background: "linear-gradient(135deg, #ffffff 40%, #ff007f 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
              margin: "0 0 12px 0",
              textTransform: "uppercase",
              letterSpacing: "-1px",
            }}
          >
            Tap Follow
          </h2>

          <p
            style={{
              fontFamily: "var(--font-title)",
              fontSize: "24px",
              fontWeight: 700,
              color: "#ffffff",
              margin: 0,
              opacity: 0.7,
              lineHeight: 1.4,
            }}
          >
            For your daily dose of amazing tech insights
          </p>
        </div>

        {/* Action button-like element */}
        <div
          style={{
            background: "linear-gradient(90deg, #00f2fe, #ff007f)",
            padding: "14px 40px",
            borderRadius: "50px",
            boxShadow: "0 0 20px rgba(0, 242, 254, 0.4)",
            marginTop: "16px",
          }}
        >
          <span
            style={{
              fontFamily: "var(--font-title)",
              fontSize: "18px",
              fontWeight: 800,
              color: "#060713",
              textTransform: "uppercase",
              letterSpacing: "2.5px",
            }}
          >
            @TheDigitalBullet
          </span>
        </div>
      </div>
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
